import { render } from "./OverviewRegistration.vue?vue&type=template&id=08817964&scoped=true"
import script from "./OverviewRegistration.vue?vue&type=script&lang=js"
export * from "./OverviewRegistration.vue?vue&type=script&lang=js"

import "@/assets/css/dashStyle.css?vue&type=style&index=0&id=08817964&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08817964"]])

export default __exports__